import React from 'react';
import { OtpInput } from '@/components/ui/otpInput';
import { Button } from '@/components/ui/button';
import { IoArrowBack } from 'react-icons/io5';

interface Props {
  mobileOtp: string;
  setMobileOtp: (value: string) => void;
  mobileTimer: number;
  mobileOtpError: string;
  submitError?: string;
  handleResend: () => void;
  submit: () => void;
  onBack: () => void;
  email: string;
}

export default function OtpVerification({
  mobileOtp,
  setMobileOtp,
  mobileTimer,
  mobileOtpError,
  submitError,
  handleResend,
  submit,
  onBack,
  email,
}: Props) {
  return (
    <div className="space-y-5 sm:space-y-6 w-full max-w-[420px] px-4 sm:px-6 mx-auto">
      <div className="flex items-center justify-center">
        <img src="/images/logo.svg" alt="logo" className="w-[140px] sm:w-[160px] md:w-[180px]" />
      </div>

      <div className="text-center">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white">Enter Your OTP</h2>

        <p className="text-sm sm:text-base md:text-lg text-white mt-2">
          We sent a code to{' '}
          <span className="text-[#0680D0] break-all">
            {email?.replace(/(.{3}).+(@.+)/, '$1*****$2')}{' '}
          </span>
        </p>
      </div>

      <div className="flex justify-center">
        <OtpInput value={mobileOtp} onChange={setMobileOtp} />
      </div>

      {mobileOtpError && (
        <p className="text-xs sm:text-sm text-destructive text-center">{mobileOtpError}</p>
      )}
      {submitError && (
        <p className="text-xs sm:text-sm text-destructive text-center">{submitError}</p>
      )}

      <p className="text-xs sm:text-sm text-center text-muted-foreground">
        {mobileTimer > 0 ? (
          <>
            Resend OTP in <span className="font-semibold text-white">{mobileTimer}s</span>
          </>
        ) : (
          <span className="text-white cursor-pointer font-semibold" onClick={handleResend}>
            Didn't receive the code? <span className="underline text-[#0680D0]">Resend</span>
          </span>
        )}
      </p>

      <Button
        variant="auth"
        type="button"
        className="w-full h-[44px] sm:h-[48px] text-sm sm:text-base"
        onClick={submit}
      >
        Sign Up
      </Button>

      <button
        className="flex mx-auto items-center gap-2 bg-white/5 hover:bg-white/10 transition
                   text-white rounded-full py-3 sm:py-4 px-6 sm:px-8 text-sm sm:text-base"
        onClick={onBack}
      >
        <IoArrowBack />
        Back
      </button>
    </div>
  );
}
